import React, { useState, useEffect } from "react"
import Reply from "../../../images/Reply.svg"
import * as Style from "../Comments.module.scss"
import Discussion from "../Discussion"
import ReplyComment from "./ReplyComment"

const SingleComment = ({
  id,
  user_name,
  date_time,
  content,
  strapi_id,
  discussion,
  mode,
  subposts,
  colorTarget,
  setColorTarget,
}) => {
  const [showReply, setShowReply] = useState(false)
  const [invalidMessage, setInvalidMessage] = useState(false)
  const [inputValue, setInputValue] = useState("")
  // const [colorTarget, setColorTarget] = useState(null)
  const subPostForThisPost = subposts.filter(ele => {
    return ele.attributes.main_post_id === id
  })

  const dateAndTime =
    new Date(date_time)
      .toLocaleString("en-GB", {
        timeZone: "Europe/Sofia",
      })
      .slice(0, -3)
      .replace(",", "") + " ч."

  const showReplyhandler = () => {
    setShowReply(!showReply)
    if (!showReply) {
      setColorTarget(null)
    }
  }

  const colorTargethandler = color_target => {
    setColorTarget(color_target)
  }

  const blurHandler = () => {
    setTimeout(() => {
      showReplyhandler()
    }, 100)
  }

  return (
    <React.Fragment>
      <div id={id} key={id} className={Style.wholeCommentWrapper}>
        <div className={Style.wrapper}>
          <div className={Style.avatar}></div>
          <div className={Style.nameContentWrap}>
            <div className={Style.nameOptions}>
              <div className={Style.name}>{user_name}</div>
              <div onMouseDown={showReplyhandler} className={Style.options}>
                <div className={Style.replyIcon}>
                  <Reply />
                </div>
                <div className={Style.reply}>Reply </div>
              </div>
            </div>
            <div className={Style.content}></div>
          </div>
        </div>
        <p className={Style.contentText}>{content}</p>
        <p className={Style.dateTime}>{dateAndTime}</p>
        {showReply && (
          <Discussion
            showReply={showReply}
            blurHandler={blurHandler}
            strapi_id={strapi_id}
            discussion={discussion}
            mode={mode}
            close={showReplyhandler}
            mainId={id}
          />
        )}
      </div>
      {subPostForThisPost.map(comment => {
        return (
          <ReplyComment
            showReply={showReply}
            colorTarget={colorTarget}
            colorTargethandler={colorTargethandler}
            navigatePost={comment.attributes.nav_id}
            original_post={comment.attributes.original_post}
            original_author={comment.attributes.original_author}
            position={comment.attributes.position}
            main_id={comment.attributes.main_post_id}
            key={comment.id}
            nav_id={comment.id}
            mainId={id}
            user_name={comment.attributes.user_name}
            date_time={comment.attributes.date_time}
            content={comment.attributes.content}
            strapi_id={strapi_id}
            discussion={discussion}
            mode="reply-sub"
          />
        )
      })}
    </React.Fragment>
  )
}

export default SingleComment
